module.exports = __webpack_public_path__ + "static/media/480.9c087f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-pliers/light/480.png
// module id = 2354
// module chunks = 2